import { createStyles, Theme } from '@material-ui/core'

export const searchFilterCardStyles = (theme: Theme) =>
  createStyles({
    card: {
      paddingBottom: theme.spacing(1),
      marginBottom: theme.spacing(2),
      // Targetear elementos internos del Form de globaleris.ui
      '& .MuiToolbar-root': {
        marginTop: '0px !important',
        marginBottom: '0px !important',
        paddingTop: '8px !important',
        minHeight: '0px !important'
      },
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        minHeight: '0px !important',
        marginTop: '0px !important',
        marginBottom: '0px !important'
      },
      '& .makeStyles-mainSectionHeader': {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
        border: '1px red !important'
      },
      '& [class*="makeStyles-mainSectionHeader"]': {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
        border: '1px red !important'
      },
      '& .makeStyles-mainSectionTitle': {
        marginTop: '16px !important',
        padding: '0 !important',
        border: '1px red !important'
      },
      '& [class*="makeStyles-mainSectionTitle"]': {
        marginTop: '16px !important',
        padding: '0 !important',
        border: '1px red !important'
      },
      '& .MuiCardContent-root': {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(0.5),
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(1)
      },
      '& .MuiGrid-container': {
        marginTop: '0 !important',
        marginBottom: '0 !important',
        paddingLeft: '32px !important',
        paddingRight: '32px !important'
      },
      '& .MuiGrid-item': {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5)
      },
      '& .MuiFormControl-root': {
        marginTop: '0 !important',
        marginBottom: '0 !important'
      }
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    titleCustom: {
      opacity: 0.9,
      fontSize: '1.3rem',
      fontWeight: 500,
      lineHeight: 1.2,
      marginBottom: 0,
      paddingBottom: 0,
      color: theme.palette.text.primary
    }
  })
